import React from 'react'

const NewEmployee = () => {
  return (
    <div>NewEmployee</div>
  )
}

export default NewEmployee